import { GlobalStatus } from "@gtpl/shared-models/common-models";
import { BaseEntity, Column, Entity, Index, JoinColumn, JoinTable, ManyToMany, ManyToOne, OneToMany, OneToOne, PrimaryColumn, PrimaryGeneratedColumn, RelationId, VersionColumn, UpdateDateColumn, CreateDateColumn } from "typeorm";
import { SoInvoiceDetails } from "./sale-invoice-details.entity";
import { SaleOrderItems } from "./sale-order-items.entity";
import { SaleOrder } from "./sale-order.entitiy";

@Entity('so_po_details')
export class SalePoDetails {

  @PrimaryGeneratedColumn("increment", { name: 'so_po_id' })
  SoPoId: number;

  // @Column("varchar", {
  //   nullable: false,
  //   length: 20,
  //   name: "soaking_time"
  // })
  // soakingTime: string;


  // @Column("varchar", {
  //   nullable: false,
  //   length: 20,
  //   name: "hl_final_product"
  // })
  // hLFinalProduct: string;

  @Column("int", {
    nullable: true,
    name: "rating"
  })
  rating: number;

  // @Column("int", {
  //   nullable: false,
  //   name: "glazzing"
  //   //percentage
  // })
  // glazzing: number;

  @Column("text", {
    nullable: true,
    name: "additional_note"
  })
  additionalNote: string;

  @Column({
    type: 'enum',
    nullable: false,
    enum: GlobalStatus,
    default: GlobalStatus.NO,
    name: "is_brand_approved"
  })
  isBrandApproved: string;

  

  @Column("varchar",{ 
    nullable:false,
    length:30,
    name:"brandType"
  })
  brandDesignType:string;

  @Column({
    type: 'enum',
    nullable: false,
    enum: GlobalStatus,
    default: GlobalStatus.NO,
    name: "is_certified"
  })
  iscertification: string;

  // @Column("varchar",{ 
  //   nullable:false,
  //   length:30,
  //   default: GlobalStatus.NO,
  //   name:"is_certified"
  // })
  // iscertification:string;

  @Column("varchar",{ 
    nullable:true,
    length:30,
    name:"labInspection"
  })
  labInspection:string;

  @Column("varchar",{ 
    nullable:true,
    length:15,
    name:"lotCode"
  })
  lotCode:string;

  
  @Column("boolean",{ 
    nullable:false,
    default:false,
    name:"laod_inpection"
  })
  loadInspection:boolean;


  




  // @Column("varchar", {
  //   nullable: true,
  //   name: "style_weighment_id"
  // })
  // styleWeighmentId: string;

  // @Column("varchar", {
  //   nullable: true,
  //   name: "socking_style_id",
  // })
  // sockingStyleId: string;

  @Column("int", {
    nullable: false,
    name: "certification_id"
  })
  certificationId: number;

  @Column("boolean", {
    nullable: false,
    default: true,
    name: "is_active"
  })
  isActive: boolean;

  @CreateDateColumn({
    name: "created_at",
    type: "datetime"
  })
  createdAt: Date;

  @Column("varchar", {
    nullable: false,
	default:"Admin",
    name: "created_user"
  })
  createdUser: string | null;


  @UpdateDateColumn({
    name: "updated_at",
    type: 'datetime'
  })
  updatedAt: Date;

  @Column("varchar", {
    nullable: true,
    name: "updated_user"
  })
  updatedUser: string | null;

  @VersionColumn({
    default: 1,
    name: "version_flag"
  })
  versionFlag: number;

  @OneToOne(type=>SaleOrder, saleOrder=>saleOrder.SoPoDetailsInfo,{  nullable:false})
  @JoinColumn({ name:"sale_order_id"})
  saleOrderInfo: SaleOrder;
}
